import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import { useUpdateUserProfileMutation } from "config/api/waV1_user";
import { toggleError, toggleNoti } from "config/slice/message";
import { userProfileSetter } from "config/slice/global";
import { STORAGE_USER_PROFILE } from "config/const/global";
import { useTranslation } from "react-i18next";
import { KEY_COL_LABEL_USER_EMAIL, KEY_COL_LABEL_USER_NAME, KEY_COL_LABEL_USER_PHONE, KEY_COL_LABEL_USER_TITLE, KEY_ERROR_UPDATE_FAILED, KEY_LABEL_CANCEL, KEY_LABEL_CONFIRM, KEY_LABEL_PROFILE_TITLE, KEY_NOTI_UPDATE_SUCC, MODULE_PREVIEW_ROUTER_FORM } from "config/const/locale";


const IN = ['name', 'title', 'email', 'phone']

export default function Profile() {

    const { t } = useTranslation(MODULE_PREVIEW_ROUTER_FORM)
    const [iptValue, setIptValue] = React.useState({})
    const { user } = useSelector(state => state.global)
    const [upUProfileFn] = useUpdateUserProfileMutation()
    const dispatch = useDispatch()

    const I18nText = {
        'name': t(KEY_COL_LABEL_USER_NAME),
        'title': t(KEY_COL_LABEL_USER_TITLE),
        'email': t(KEY_COL_LABEL_USER_EMAIL),
        'phone': t(KEY_COL_LABEL_USER_PHONE),
    }

    const handleChg = (type) => (e) => setIptValue(p => ({ ...p, [type]: e.target.value }))

    const handleUpdate = () => {
        upUProfileFn({
            id: user?.id,
            payload: iptValue
        })
            .then(res => {
                if (res.data?.data) {
                    dispatch(userProfileSetter(res.data.data?.user))
                    localStorage.setItem(STORAGE_USER_PROFILE, JSON.stringify(res.data.data?.user))
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_NOTI_UPDATE_SUCC)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_UPDATE_FAILED)
                }))
            })
    }

    React.useEffect(() => {
        Object.keys(user).filter(i => IN.includes(i)).map(
            i => setIptValue(p => ({ ...p, [i]: user[i] }))
        )
    }, [user])

    return (
        <Box
            sx={{
                width: '80%',
                m: '0 auto'
            }}
        >
            <Typography variant="h4">{t(KEY_LABEL_PROFILE_TITLE)}</Typography>
            <Grid container spacing={2}>
                <Grid item sm={12}>&nbsp;</Grid>
                {
                    Object.keys(iptValue).map(
                        (i, index) => (
                            <React.Fragment key={index}>
                                <Grid item sm={3}>{I18nText[i]}</Grid>
                                <Grid item sm={9}><TextField value={iptValue[i]} onChange={handleChg(i)}></TextField></Grid>
                            </React.Fragment>
                        )
                    )
                }
                <Grid item sm={12}>&nbsp;</Grid>
                <Grid item sm={3} ><Button>{t(KEY_LABEL_CANCEL)}</Button></Grid>
                <Grid item sm={3} ><Button onClick={handleUpdate}>{t(KEY_LABEL_CONFIRM)}</Button></Grid>
            </Grid>
        </Box>
    );
}
